/** iPhone/iPod/iPad — inclusive iPadOS 13+, que se identifica como Mac no user agent. */
export function isIOSDevice(): boolean {
  if (typeof navigator === 'undefined') return false
  if (/iphone|ipad|ipod/i.test(navigator.userAgent)) return true
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}

/** App aberto como PWA instalado (tela inicial), não numa aba do navegador. */
export function isRunningStandalone(): boolean {
  if (typeof window === 'undefined') return false
  const displayMode = window.matchMedia?.('(display-mode: standalone)').matches ?? false
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true
  return displayMode || iosStandalone
}
